import React from "react";
import ImageDisplay from "./ImageDisplay";

export default function Arts(props) {
  return (
    <ImageDisplay
      imageCount={26}
      numberOfImagesToDisplay={props.numberOfImagesToDisplay}
      componentName={"arts"}
    />
  );
}
